import { useEffect, useRef } from 'react';
import { Brain, MonitorSmartphone, Server, Database, Cloud, Wrench } from 'lucide-react';

const categories = [
  {
    icon: <Brain size={24} />,
    name: 'Intelligence Artificielle',
    tags: ['LLMs (GPT-4, Claude)', 'LangChain', 'OpenAI API', 'NLP', 'Prompt Engineering', 'Hugging Face'],
  },
  {
    icon: <MonitorSmartphone size={24} />,
    name: 'Frontend',
    tags: ['React.js', 'Next.js', 'TypeScript', 'Tailwind CSS', 'Framer Motion', 'Zustand', 'React Query'],
  },
  {
    icon: <Server size={24} />,
    name: 'Backend',
    tags: ['Node.js', 'Python', 'Express.js', 'NestJS', 'Django', 'REST / GraphQL', 'WebSocket'],
  },
  {
    icon: <Database size={24} />,
    name: 'Base de Données',
    tags: ['PostgreSQL', 'Supabase', 'MongoDB', 'MySQL', 'Redis', 'Prisma'],
  },
  {
    icon: <Cloud size={24} />,
    name: 'Cloud & DevOps',
    tags: ['AWS', 'Vercel', 'Docker', 'GitHub Actions', 'CI/CD', 'Linux'],
  },
  {
    icon: <Wrench size={24} />,
    name: 'Outils',
    tags: ['Git / GitHub', 'Figma', 'Postman', 'VS Code', 'Jira / Agile'],
  },
];

export default function Skills() {
  const refs = useRef([]);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1 }
    );
    refs.current.forEach(r => r && obs.observe(r));
    return () => obs.disconnect();
  }, []);

  return (
    <section id="skills">
      <div className="container">
        <p className="section-label reveal" ref={el => refs.current[0] = el}>Stack Technique</p>
        <h2 className="section-title reveal" ref={el => refs.current[1] = el} style={{ transitionDelay: '0.1s' }}>
          Technologies & <em>frameworks</em>
        </h2>
        <p className="skills-intro reveal" ref={el => refs.current[2] = el} style={{ transitionDelay: '0.2s' }}>
          Des interfaces réactives aux APIs performantes — voici les outils avec lesquels
          je construis des solutions digitales modernes au quotidien.
        </p>

        <div className="tech-categories">
          {categories.map((cat, i) => (
            <div
              key={cat.name}
              className="tech-category reveal"
              ref={el => refs.current[3 + i] = el}
              style={{ transitionDelay: `${0.1 * i}s` }}
            >
              <span className="tech-cat-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--gold)' }}>
                {cat.icon}
              </span>
              <h3 className="tech-cat-name">{cat.name}</h3>
              <div className="tech-tags">
                {cat.tags.map(t => (
                  <span key={t} className="tech-tag">{t}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
